
import categoryMixin from '@/mixins/categoryMixin'

export default {
  name: 'CategoryListItem',
  mixins: [categoryMixin],
  props: {
    category: Object,
  },
  data() {
    return {
      url: this.getUrl(),
    }
  },
  computed: {
    isAdmin() {
      return (
        this.$auth.loggedIn && this.$auth.user?.role?.identifier === 'admin'
      )
    },
  },
  methods: {
    getUrl() {
      return this.subcategoryRoute(this.category)
    },
  },
}
